import { useState, useEffect } from "react";
import axios from "axios";
import appConfig from "config/appConfig";
import { verifyTokenExpire } from "middleware/verifyToken";

export const useIaDataConfig = () => {
  const [state, setState] = useState({
    isLoading: true,
    config: {
      name: appConfig?.enterprise ?? "",
      query: [],
      api_key: "",
      actived: 0,
    },
    error: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!verifyTokenExpire()) {
        setState((prev) => ({ ...prev, isLoading: false }));
        return;
      }

      try {
        const configResponse = await axios.get(
          `${appConfig.apiDomaine}/configurations/satisfaction-data-config`
        );

        const apiKey = configResponse.data?.api_key;
        const actived = configResponse.data?.actived === "1" ? 1 : 0;

        let query = [];

        if (apiKey) {
          try {
            const externalResponse = await axios.get(
              `http://212.83.146.159:5550/api/v1/dash/data`,
              {
                headers: {
                  Authorization: `Bearer ${apiKey}`,
                  "App-name": appConfig?.enterprise ?? "",
                },
              }
            );
            query = externalResponse.data.data.query || [];
          } catch (externalError) {
            console.warn("Failed to fetch external data:", externalError);
          }
        }

        setState({
          isLoading: false,
          config: {
            name: appConfig?.enterprise ?? "",
            query,
            api_key: apiKey || "",
            actived,
          },
          error: null,
        });
      } catch (error) {
        setState((prev) => ({
          ...prev,
          isLoading: false,
          error: error.message,
        }));
      }
    };

    fetchData();
  }, []);

  return state;
};
